import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const http = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
});

export function appendLangToRequest(config: AxiosRequestConfig) {
    const i18n = require('@/i18n').default;
    const lang = i18n.locale || 'en';
    if (config.params) {
        config.params.lang = lang;
    } else {
        config.params = { lang };
    }
    return config;
}

export function addPortalAccessTokenInHeaders(config: AxiosRequestConfig) {
    const store = require('@/store').default;
    if (store.state.session?.portalAccessToken) {
        config.headers = config.headers || {};
        config.headers['x-portal-access-token'] = store.state.session.portalAccessToken;
    }
    return config;
}

export async function handleResponseError(error: any) {
    const store = require('@/store').default;

    if (error?.response?.data?.hideErrNotif) {
        return Promise.reject(error);
    }

    if (error?.response?.status === 401) {
        await store.dispatch('session/logOut');
    } else {
        await store.dispatch('addError', { error });
    }
    return Promise.reject(error);
}

export function handleResponseSuccess(response: AxiosResponse) {
    return response;
}

http.interceptors.request.use(appendLangToRequest);

http.interceptors.request.use(addPortalAccessTokenInHeaders);

http.interceptors.response.use(handleResponseSuccess, handleResponseError);

export default http;
